var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerSupplymintLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.0498,
    y: 0.0078125,
    width: 38,
    height: 38,
    rx: 6.33333,
    fill: "#5D5FEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9192,
    y: 10.0352,
    width: 1.69643,
    height: 9.04762,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8638,
    y: 8.6875,
    width: 1.69643,
    height: 15.0046,
    transform: "rotate(51.8154 31.8638 8.6875)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2112,
    y: 19.3867,
    width: 1.69643,
    height: 12.6055,
    transform: "rotate(33.096 32.2112 19.3867)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3975,
    y: 19.3516,
    width: 1.69643,
    height: 12.6055,
    transform: "rotate(-24.7049 20.3975 19.3516)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1836,
    y: 18.5938,
    width: 1.69643,
    height: 11.8788,
    transform: "rotate(27.4657 44.1836 18.5938)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9844,
    y: 20.1055,
    width: 1.69643,
    height: 21.9476,
    transform: "rotate(-62.2575 19.9844 20.1055)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45.2034,
    y: 19.0273,
    width: 1.69643,
    height: 22.1259,
    transform: "rotate(62.9104 45.2034 19.0273)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.05,
    cy: 8.90644,
    r: 2.2619,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.05,
    cy: 19.0861,
    r: 2.2619,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7409,
    cy: 19.0861,
    r: 2.2619,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2639,
    cy: 29.2619,
    r: 2.2619,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.3601,
    cy: 19.0861,
    r: 2.2619,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.8359,
    cy: 29.2619,
    r: 2.2619,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9083_11213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.91284,
    y: 42.1016,
    width: 58,
    height: 14,
    rx: 7,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3508 45.6756C12.1608 45.6756 12.8298 45.8886 13.3578 46.3146C13.8918 46.7406 14.2368 47.3166 14.3928 48.0426H12.7638C12.6438 47.7486 12.4578 47.5176 12.2058 47.3496C11.9598 47.1816 11.6658 47.0976 11.3238 47.0976C10.8738 47.0976 10.5108 47.2626 10.2348 47.5926C9.95884 47.9226 9.82084 48.3636 9.82084 48.9156C9.82084 49.4676 9.95884 49.9086 10.2348 50.2386C10.5108 50.5626 10.8738 50.7246 11.3238 50.7246C11.6658 50.7246 11.9598 50.6406 12.2058 50.4726C12.4578 50.3046 12.6438 50.0766 12.7638 49.7886H14.3928C14.2368 50.5086 13.8918 51.0846 13.3578 51.5166C12.8298 51.9426 12.1608 52.1556 11.3508 52.1556C10.7328 52.1556 10.1898 52.0206 9.72184 51.7506C9.25384 51.4746 8.89084 51.0906 8.63284 50.5986C8.38084 50.1066 8.25484 49.5456 8.25484 48.9156C8.25484 48.2856 8.38084 47.7246 8.63284 47.2326C8.89084 46.7406 9.25384 46.3596 9.72184 46.0896C10.1898 45.8136 10.7328 45.6756 11.3508 45.6756ZM16.7494 45.7386V49.4106C16.7494 49.8306 16.8424 50.1516 17.0284 50.3736C17.2204 50.5956 17.4964 50.7066 17.8564 50.7066C18.2164 50.7066 18.4894 50.5956 18.6754 50.3736C18.8674 50.1516 18.9634 49.8306 18.9634 49.4106V45.7386H20.5024V49.4106C20.5024 50.0106 20.3854 50.5176 20.1514 50.9316C19.9174 51.3396 19.5964 51.6486 19.1884 51.8586C18.7864 52.0626 18.3304 52.1646 17.8204 52.1646C17.3104 52.1646 16.8604 52.0626 16.4704 51.8586C16.0804 51.6546 15.7744 51.3456 15.5524 50.9316C15.3304 50.5176 15.2194 50.0106 15.2194 49.4106V45.7386H16.7494ZM26.1028 50.3106C26.1028 50.6466 26.0158 50.9556 25.8418 51.2376C25.6738 51.5196 25.4218 51.7446 25.0858 51.9126C24.7558 52.0806 24.3538 52.1646 23.8798 52.1646C23.1658 52.1646 22.5778 51.9906 22.1158 51.6426C21.6538 51.2946 21.4018 50.8086 21.3598 50.1846H22.9978C23.0218 50.4246 23.1058 50.6136 23.2498 50.7516C23.3998 50.8896 23.5888 50.9586 23.8168 50.9586C24.0148 50.9586 24.1708 50.9046 24.2848 50.7966C24.3988 50.6886 24.4558 50.5446 24.4558 50.3646C24.4558 50.2026 24.4018 50.0676 24.2938 49.9596C24.1918 49.8516 24.0628 49.7646 23.9068 49.6986C23.7508 49.6266 23.5348 49.5426 23.2588 49.4466C22.8568 49.3086 22.5268 49.1766 22.2688 49.0506C22.0168 48.9186 21.7978 48.7266 21.6118 48.4746C21.4318 48.2166 21.3418 47.8836 21.3418 47.4756C21.3418 47.0976 21.4378 46.7706 21.6298 46.4946C21.8218 46.2186 22.0858 46.0086 22.4218 45.8646C22.7638 45.7146 23.1538 45.6396 23.5918 45.6396C24.2998 45.6396 24.8608 45.8076 25.2748 46.1436C25.6948 46.4796 25.9318 46.9416 25.9858 47.5296H24.3208C24.2908 47.3196 24.2128 47.1546 24.0868 47.0346C23.9668 46.9086 23.8018 46.8456 23.5918 46.8456C23.4118 46.8456 23.2648 46.8936 23.1508 46.9896C23.0428 47.0856 22.9888 47.2266 22.9888 47.4126C22.9888 47.5626 23.0368 47.6916 23.1328 47.7996C23.2348 47.9016 23.3608 47.9856 23.5108 48.0516C23.6608 48.1176 23.8768 48.2016 24.1588 48.3036C24.5668 48.4416 24.8998 48.5796 25.1578 48.7176C25.4158 48.8496 25.6378 49.0446 25.8238 49.3026C26.0098 49.5606 26.1028 49.8966 26.1028 50.3106ZM31.5256 45.7386V46.9626H29.7976V52.1016H28.2496V46.9626H26.5396V45.7386H31.5256ZM35.1983 45.6396C35.7983 45.6396 36.3413 45.7806 36.8273 46.0626C37.3193 46.3386 37.7063 46.7256 37.9883 47.2236C38.2703 47.7156 38.4113 48.2736 38.4113 48.8976C38.4113 49.5216 38.2673 50.0826 37.9793 50.5806C37.6973 51.0786 37.3103 51.4686 36.8183 51.7506C36.3323 52.0266 35.7923 52.1646 35.1983 52.1646C34.6043 52.1646 34.0613 52.0266 33.5693 51.7506C33.0833 51.4686 32.6963 51.0786 32.4083 50.5806C32.1263 50.0826 31.9853 49.5216 31.9853 48.8976C31.9853 48.2736 32.1263 47.7156 32.4083 47.2236C32.6963 46.7256 33.0833 46.3386 33.5693 46.0626C34.0613 45.7806 34.6043 45.6396 35.1983 45.6396ZM35.1983 47.0706C34.6943 47.0706 34.2923 47.2356 33.9923 47.5656C33.6983 47.8896 33.5513 48.3336 33.5513 48.8976C33.5513 49.4556 33.6983 49.8996 33.9923 50.2296C34.2923 50.5596 34.6943 50.7246 35.1983 50.7246C35.6963 50.7246 36.0953 50.5596 36.3953 50.2296C36.6953 49.8996 36.8453 49.4556 36.8453 48.8976C36.8453 48.3396 36.6953 47.8956 36.3953 47.5656C36.1013 47.2356 35.7023 47.0706 35.1983 47.0706ZM46.4309 45.7836V52.1016H44.8919V48.1506L43.5239 52.1016H42.1919L40.8149 48.1416V52.1016H39.2759V45.7836H41.1569L42.8759 50.1846L44.5589 45.7836H46.4309ZM49.0326 46.9626V48.2946H51.1836V49.4556H49.0326V50.8686H51.4536V52.1016H47.4936V45.7386H51.4536V46.9626H49.0326ZM55.5946 52.1016L54.2176 49.6986H53.8666V52.1016H52.3276V45.7386H54.9556C55.4596 45.7386 55.8856 45.8256 56.2336 45.9996C56.5816 46.1736 56.8426 46.4136 57.0166 46.7196C57.1906 47.0196 57.2776 47.3646 57.2776 47.7546C57.2776 48.2166 57.1486 48.6096 56.8906 48.9336C56.6386 49.2576 56.2696 49.4796 55.7836 49.5996L57.2956 52.1016H55.5946ZM53.8666 48.6456H54.8206C55.1266 48.6456 55.3516 48.5796 55.4956 48.4476C55.6396 48.3096 55.7116 48.1086 55.7116 47.8446C55.7116 47.5926 55.6366 47.3946 55.4866 47.2506C55.3426 47.1066 55.1206 47.0346 54.8206 47.0346H53.8666V48.6456Z",
    fill: "#23235F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9083_11213",
    x: -1.08716,
    y: 39.1016,
    width: 68,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.863365 0 0 0 0 0.859271 0 0 0 0 0.9125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9083_11213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9083_11213",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupplymintLogo);
export default __webpack_public_path__ + "static/media/CustomerSupplymintLogo.e5c106182956cfc6ef4c78dc6f8edcbd.svg";
export { ForwardRef as ReactComponent };